import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Course ID options with subtitle
 */
const COURSE_OPTIONS = [
  { id: "CSE101", name: "Introduction to Computer Science" },
  { id: "CSE102", name: "Data Structures" },
  { id: "MAT201", name: "Engineering Mathematics" },
  { id: "SCI301", name: "Applied Physics" },
];

export default function AddCourseDialog({ open, onClose, onCreate }) {
  const [course, setCourse] = useState(null);
  const [students, setStudents] = useState("");

  const handleCreate = () => {
    onCreate({
      id: course.id,
      name: course.name,
      students: Number(students),
    });
    setCourse(null);
    setStudents("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" 
    // sx={{gap:2}}
    >
      <DialogTitle>Add New Course</DialogTitle>
      

      <DialogContent sx={{ display: "grid", gap: 2, mt: 2 }}>
        {/* Course ID Dropdown with Subtitle */}
        <br/>
        <Autocomplete
          options={COURSE_OPTIONS}
          value={course}
          onChange={(event, newValue) => setCourse(newValue)}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Box>
                <Typography fontWeight={600}>{option.id}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.name}
                </Typography>
              </Box>
            </Box>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Course ID" placeholder="Select course" />
          )}
        />

        {/* Number of Students */}
        <TextField
          label="Number of Students"
          type="number"
          value={students}
          onChange={(e) => setStudents(e.target.value)}
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleCreate}
          disabled={!course || !students}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
